import { render, staticRenderFns } from "./skill.vue?vue&type=template&id=0f394112&"
import script from "./skill.vue?vue&type=script&lang=js&"
export * from "./skill.vue?vue&type=script&lang=js&"
import style0 from "./skill.vue?vue&type=style&index=0&id=0f394112&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports